import { Link } from "react-router-dom";
import HeroPolicy from "@/components/common/HeroPolicy";
import Container from "@/components/layout/Container";

type LinkItem = { name: string; path: string; external?: boolean };
type Subsection = { subtitle: string; links: LinkItem[] };
type SitemapSection = { title: string; links: LinkItem[]; subsections?: Subsection[] };

const sitemapData: SitemapSection[] = [
  {
    title: "바로가기 서비스",
    links: [
      { name: "관리자 정산 시스템", path: "https://customer.std-ums.com/", external: true },
      { name: "문의 접수", path: "/voc/submit" },
      { name: "문의 조회", path: "/voc/check" },
      { name: "서비스 신청", path: "/service/submit" },
    ],
  },
  {
    title: "회사소개",
    links: [
      { name: "경영이념", path: "/about/vision" },
      { name: "연혁", path: "/about/history" },
      { name: "보유기술 및 특허", path: "/about/technology" },
      { name: "주요 고객사", path: "/about/clients" },
      { name: "오시는 길", path: "/about/location" },
    ],
  },
  {
    title: "서비스 소개",
    links: [
      { name: "메시징 서비스", path: "/service-provide/messaging" },
      { name: "문자콜센터 서비스", path: "/service-provide/voucher-aicc" },
    ],
  },
  {
    title: "정책",
    links: [
      { name: "이용약관", path: "/policy/terms" },
      { name: "개인정보처리방침", path: "/policy/privacy" },
      { name: "이메일무단수집거부", path: "/policy/email-refusal" },
    ],
  },
];

const Sitemap = () => {
  return (
    <Container>
      <HeroPolicy />

      <main className="min-h-screen px-[2rem] wide:px-0">
        <div className="py-[70px]">
          {/* Content */}
          <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
            {sitemapData.map((section, idx) => (
              <div key={idx} className="sitemap-section">
                <h2 className="text-[1.8rem] font-bold text-navy mb-6 pb-4 border-b border-gray-2">
                  {section.title}
                </h2>

                {/* Regular links */}
                {section.links && (
                  <ul className="space-y-3">
                    {section.links.map((link, linkIdx) => (
                      <li key={linkIdx}>
                        {link.external ? (
                          <a
                            href={link.path}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 text-[1.6rem] text-gray-6 hover:text-navy transition-colors"
                          >
                            <span className="material-icons-round text-[1.5rem] text-gray-4">
                              chevron_right
                            </span>
                            {link.name}
                          </a>
                        ) : (
                          <Link
                            to={link.path}
                            className="flex items-center gap-2 text-[1.6rem] text-gray-6 hover:text-navy transition-colors"
                          >
                            <span className="material-icons-round text-[1.6rem] text-gray-4">
                              chevron_right
                            </span>
                            {link.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Subsections (for 사업분야) */}
                {section.subsections && (
                  <div className="space-y-6">
                    {section.subsections.map((sub, subIdx) => (
                      <div key={subIdx}>
                        <h3 className="text-[1.5rem] font-semibold text-gray-7 mb-3">
                          {sub.subtitle}
                        </h3>
                        <ul className="pl-2 space-y-2">
                          {sub.links.map((link, linkIdx) => (
                            <li key={linkIdx}>
                              <Link
                                to={link.path}
                                className="flex items-center gap-2 text-[1.4rem] text-gray-5 hover:text-navy transition-colors"
                              >
                                <span className="material-icons-round text-[1.2rem] text-gray-4">
                                  chevron_right
                                </span>
                                {link.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </Container>
  );
};

export default Sitemap;
